import axios from "./axios";
export const getForm = id => axios.get(`/forms/v1/${id}`);
export const getForms = (accountId, page) => {
  return axios.get(`/accounts/v1/${accountId}/forms?page=${page}`).then(_ref => {
    let {
      data
    } = _ref;
    Array.isArray(data) && data.map(el => {
      try {
        el.list = JSON.parse(el.list);
        el.detail = JSON.parse(el.detail);
      } catch (error) {
        console.warn(error);
      }
      return el;
    });
    return data;
  });
};
export const deleteForm = id => axios.delete(`/forms/v1/${id}`);
export const getImages = id => axios.get(`/forms/v1/${id}/documents`);
export const getUploadImageUrl = (id, data) => axios.post(`/forms/v1/${id}/documents`, data);
export const uploadImage = (url, data) => axios.put(url, data);
export const deleteImage = id => axios.delete(`/documents/v1/${id}`);

// Templates

export const getFormTemplates = () => axios.get('/forms/v1/templates');
export const getFormTemplate = id => axios.get(`/forms/v1/${id}/templates`);
export const createFormTemplate = data => axios.post('/forms/v1/templates', data);
export const updateFormTemplate = (id, data) => axios.put(`/forms/v1/${id}/templates`, data);
export const deleteFormTemplate = id => axios.delete(`/forms/v1/${id}/templates`);